import { createContext } from 'react';
import { FlightSearch } from 'ts/flight/interfaces/FlightSearch';
import { RoundTripMode } from 'constants/flight';

interface FlightsResult {
  outboundFlight?: FlightSearch;
  inboundFlight?: FlightSearch;
  setOutboundFlight: (flight?: FlightSearch) => void;
  setInboundFlight: (flight?: FlightSearch) => void;
  roundTripMode: RoundTripMode;
  setRoundTripMode: (mode: RoundTripMode) => void;
  onClickChoose: (flight: FlightSearch, sessionStorageKey: string) => void;
}

export const FlightsResultContext = createContext<FlightsResult | undefined>(undefined);
